//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from "store/constants";
import { cloneDeep, map } from "lodash";

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------

const booksAllInitial = [];

export const booksAllList = (state = booksAllInitial, action) => {
  switch (action.type) {
    case ActionTypes.books.listAllBooksSuccess:
      return action.payload;
    case ActionTypes.books.listBooksByIdsSuccess:
      const booksMap = new Map(state.map(book => [book.id, book]));
      action.payload.forEach(book => {
        booksMap.set(book.id, book);
      });
      return Array.from(booksMap.values());
    case ActionTypes.books.createBookSuccess:
      return [...state, action.payload];
    case ActionTypes.books.updateBookSuccess:
      const updateIndex = state.findIndex(b => b.id == action.payload.id);
      if (updateIndex === -1) {
        return state;
      }
      return [
        ...state.slice(0, updateIndex),
        { ...state[updateIndex], ...action.payload },
        ...state.slice(updateIndex + 1)
      ];
    case ActionTypes.books.listAllBooksFail:
      return state;
    case ActionTypes.books.addEditBook:
      const indexToUpdate = state.findIndex(
        (item) => item.id === action.payload.id
      );
      if (indexToUpdate !== -1) {
        if (!action.payload.active) {
          return [
            ...state.slice(0, indexToUpdate),
            ...state.slice(indexToUpdate + 1)
          ];
        } else {
          return [
            ...state.slice(0, indexToUpdate),
            action.payload,
            ...state.slice(indexToUpdate + 1)
          ];
        }
      } else if (action.payload.active) {
        return [...state, action.payload];
      }
      return state;
    default:
      return state;
  }
};

export const bookOrder = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.books.setBookOrder:
      return action.payload;
    case ActionTypes.books.setBookOrderSuccess:
      return action.payload;
    case ActionTypes.books.setBookOrderFail:
      return state;
    default:
      return state;
  }
};

const booksAllActiveInActive = [];

export const booksActiveInActive = (state = booksAllActiveInActive, action) => {
  switch (action.type) {
    case ActionTypes.booksActiveInactive.listBooksActiveInactiveSuccess:
      return action.payload;
    case ActionTypes.booksActiveInactive.createBookActiveInactiveSuccess:
      return [...state, action.payload];
    case ActionTypes.booksActiveInactive.updateBookActiveInactiveSuccess:
      const bk = cloneDeep(state);
      return map(bk, (b) => {
        if (b.id == action.payload.id) {
          return { ...b, ...action.payload };
        }
        return b;
      });

    default:
      return state;
  }
};

const int_book_allowed = {
  allowed_book: [],
  other_permissions: {
    "one_informate": true,
    "comunidad": true,
    "balcon": true,
    "conectandome": true,
    "ap": true,
    "story": true,
    "exam": true,
    "resourses": true
  },
  books_group: [],
  externalLinkBooks:[],
  extra_books:[]
}
export const userAllowedBooks = (state = int_book_allowed, action) => {
  switch (action.type) {
    case ActionTypes.userBooks.setUserAllowedBooks:
      return action.payload;
    case ActionTypes.userBooks.updateUserAllowedBooks:
      return action.payload;
    default:
      return state;
  }
};

const booksCoverInitial = [];

export const booksCoverList = (state = booksCoverInitial, action) => {
  switch (action.type) {
    case ActionTypes.books.listBooksCoverSuccess:
      return action.payload;
    case ActionTypes.books.listBooksCoverFail:
      return state;
    default:
      return state;
  }
};